module.exports = __webpack_public_path__ + "static/img/PerennialSociete_success.b796aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PerennialSociete_success.png
// module id = 285
// module chunks = 1